import { isEmpty } from "lodash";
import {
  ConditionalLogicGrouping,
  ConditionalLogicGroupingOperators,
  FieldBlockConditionalLogicItem,
} from "../../schema";

function getOperators(
  grouping: ConditionalLogicGrouping
): ConditionalLogicGroupingOperators {
  const operators: ConditionalLogicGroupingOperators = [];

  // Since the ConditionalLogicGrouping type has "and" and "or" as mutually exclusive,
  // we have to make sure the property is in the object
  if ("and" in grouping) {
    operators.push("and");
    grouping.and.forEach((item) => {
      if (typeof item !== "number") {
        operators.push(...getOperators(item));
      }
    });
  } else if ("or" in grouping) {
    operators.push("or");
    grouping.or.forEach((item) => {
      if (typeof item !== "number") {
        operators.push(...getOperators(item));
      }
    });
  }

  return operators;
}

export function getOperatorsFromGrouping(
  grouping: ConditionalLogicGrouping
): ConditionalLogicGroupingOperators {
  // Reverse is needed here since we built the array from the bottom up
  return [...getOperators(grouping)].reverse();
}

export function groupConditions(
  conditions: FieldBlockConditionalLogicItem[],
  ops: ConditionalLogicGroupingOperators
) {
  if (conditions.length <= 1 || ops.length < 1) {
    return undefined;
  }

  const groupings = ops.reduce<ConditionalLogicGrouping>((acc, op, index) => {
    if (index === 0) {
      // Since the ConditionalLogicGrouping type has "and" and "or" as mutually exclusive
      // We can't do { [op]: [0, 1]}. We've to do the "if" first
      if (op === "and") {
        return {
          and: [0, 1],
        };
      } else {
        return {
          or: [0, 1],
        };
      }
    }

    if (op === "and") {
      return {
        and: [acc, index + 1],
      };
    } else {
      return {
        or: [acc, index + 1],
      };
    }
  }, {} as ConditionalLogicGrouping);

  if (isEmpty(groupings)) {
    return undefined;
  }

  return groupings;
}
